const PRINCIPLES = [
  { icon: "ri-vidicon-line", title: "逐帧还原", desc: "对视频、图片、口播做帧级比对与时间线核对，把翻车现场拆解成可回溯的证据步骤。" },
  { icon: "ri-archive-2-line", title: "证据优先", desc: "仅整理有公开来源的素材，单篇内容会保留支持方与反对方视角，避免断章取义。" },
  { icon: "ri-file-list-3-line", title: "持续归档", desc: "每个事件都有独立档案与状态标签，进展更新后按时间补录，供你随时回看完整过程。" },
  { icon: "ri-scales-3-line", title: "中立立场", desc: "我们只做素材的搬运与整理者，不做裁判。立场以公开信息为基准，不预设结论。" },
];

const TESTIMONIALS = [
  {
    name: "柚子不加糖",
    role: "吃瓜读者 · 上海",
    text: "以前追海外网红塌房要从好几个平台来回翻，现在一个页面就能看完整时间线，逐帧还原那栏真的太顶了。",
    icon: "ri-community-line",
  },
  {
    name: "Momo 老六",
    role: "内容搬运观察者",
    text: "最欣赏的是会同时放两边素材、还标注待实锤，不会像某些营销号一样一锤定音带节奏。",
    icon: "ri-lightbulb-flash-line",
  },
  {
    name: "晚风",
    role: "娱乐区小编",
    text: "人物档案按状态分类这点很实用，选题找灵感时直接进来扫一遍「发酵中」的，效率翻倍。",
    icon: "ri-compass-3-line",
  },
];

const BRAND_IMG =
  "https://readdy.ai/api/search-image?query=Warm%20cream%20editorial%20illustration%20of%20a%20desk%20filled%20with%20archival%20folders%2C%20magnifying%20glass%2C%20sticky%20notes%20and%20a%20retro%20monitor%20showing%20news%20timeline%2C%20coral%20red%20and%20amber%20gold%20color%20pop%2C%20organized%20evidence%20files%2C%20documentary%20newsroom%20aesthetic%2C%20high%20detail%20digital%20illustration%2C%20no%20people&width=900&height=760&seq=gossip-about-brand&orientation=portrait";

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100 py-14 md:py-20 border-y border-background-200 overflow-hidden">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="rounded-3xl overflow-hidden">
              <img src={BRAND_IMG} alt="海外吃瓜内容聚合与证据归档站工作台插图" className="w-full h-[420px] md:h-[520px] object-top object-cover" />
            </div>
            <div className="absolute -bottom-5 left-4 md:left-6 rounded-2xl bg-background-50 border border-background-200 px-5 py-4 shadow-none flex items-center gap-4">
              <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-accent-500 text-background-50">
                <i className="ri-honour-line text-xl"></i>
              </span>
              <div>
                <p className="font-latin text-2xl text-foreground-950 leading-none">2019</p>
                <p className="text-xs text-foreground-600 mt-1">开启海外吃瓜记录</p>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span> 关于海外吃瓜
            </p>
            <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950">
              聚合全球网红黑料，
              <br className="hidden md:block" />
              只做清醒的整理者
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              海外吃瓜是一间专注于「海外网红黑料与博主翻车」的中文信息聚合站。面对零散、真假难辨的爆料，我们把证据、截图与讨论按话题整理成清晰档案，让每一位关注海外创作者的读者都能用最少的时间看清争议全貌。
            </p>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              我们相信吃瓜不等于站队。尊重事实、证据优先、持续更新，是我们沉淀下来的三条内容底色。
            </p>

            <div className="mt-7 grid sm:grid-cols-2 gap-3">
              {PRINCIPLES.map((p) => (
                <div key={p.title} className="flex gap-3 rounded-2xl bg-background-50 border border-background-200 p-4">
                  <span className="flex items-center justify-center w-10 h-10 rounded-xl bg-secondary-100 text-secondary-700 shrink-0">
                    <i className={`${p.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading font-bold text-base text-foreground-950">{p.title}</h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* testimonials */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {TESTIMONIALS.map((t) => (
            <figure key={t.name} className="rounded-2xl bg-background-50 border border-background-200 p-5 hover:border-primary-300 transition-colors">
              <div className="flex items-center gap-1 text-accent-500 text-sm">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
              <blockquote className="mt-3 text-sm text-foreground-700 leading-relaxed">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-primary-100 text-primary-600">
                  <i className={t.icon}></i>
                </span>
                <div className="leading-tight">
                  <p className="font-medium text-sm text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500 mt-0.5">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}